import { useEffect } from 'react';
import { trackConversion } from '../../utils/analytics';

const AnalyticsContactClickTracker: React.FC = () => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const link = target.closest('a[href^="tel:"], a[href^="mailto:"]');
      if (!link) return;

      const href = link.getAttribute('href') || '';
      if (href.startsWith('tel:')) {
        trackConversion('contact_click', {
          method: 'phone',
          link_url: href.slice(0, 80),
        });
        return;
      }
      if (href.startsWith('mailto:')) {
        trackConversion('contact_click', {
          method: 'email',
          link_url: href.slice(0, 80),
        });
      }
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
};

export default AnalyticsContactClickTracker;
